import { gql } from '@apollo/client';

export const GET_INDICATOR_WITH_PERIOD_DATES = gql`
  query GetIndicatorWithPeriodDates($input: IndicatorPeriodDatesInput) {
    indicatorWithPeriodDates: getIndicatorWithPeriodDates(input: $input) {
      indicator {
        id
        timeline
        startDate
        indicatorPeriodType
        period {
          id
          name
        }
      }
      periodGroup {
        id
        name
        startDate
        numOfPeriods
        startDate
        numOfPeriods
        frequency {
          id
          name
        }
      }
      currencyGroup {
        id
        name
        exchangeRate
        frequency {
          id
          name
        }
      }
      periods {
        id
        label
        periodDate
        periodNumber
        value
      }
    }
  }
`;
